export const parseJwt = (token: string) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );
    return JSON.parse(jsonPayload);
};

export const validateSession = () => {
    const user = JSON.parse(localStorage.getItem('profile') || '{}');
    if (!user || !user.token) {
        return;
    }
    const payload = parseJwt(user.token);
    if (payload && payload.dataUser && payload.dataUser.version_login !== 2) {
        if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
            //SSR Validation, execute only in client
            localStorage.clear();
            window.location.href = '/logout';
        }
    }
};
